// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Poq7J","footer":"styles_footer__2hgEy","passCodeTooltip":"styles_passCodeTooltip__3bHyz"};